import React from 'react';
import EmployeeCalendar from './EmployeeCalendar';

const BirthdayCalendar = ()=><EmployeeCalendar  accessor={'birthday'} />;

export default BirthdayCalendar;
